(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-bubbles"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.getElementById('CategoryBubbles');
    if (!section) return;

    const spacer = document.getElementById('CategoryBubblesSpacer');
    const bubbles = section.querySelectorAll('.category-bubble');
    if (!bubbles.length) return;

    const stickyEnabled = section.dataset.stickyEnabled === 'true';
    const stickyOffset = parseInt(section.dataset.stickyOffset, 10) || 0;

    let originalTop = 0;
    let originalHeight = 0;
    let isPinned = false;

    function measureSection() {
      const rect = section.getBoundingClientRect();
      if (!isPinned) {
        originalTop = rect.top + window.pageYOffset;
        originalHeight = section.offsetHeight;
      }
    }

    function pinSection() {
      if (isPinned) return;
      isPinned = true;
      spacer.style.height = originalHeight + 'px';
      section.classList.add('is-pinned');
    }

    function unpinSection() {
      if (!isPinned) return;
      isPinned = false;
      spacer.style.height = '';
      section.classList.remove('is-pinned');
    }

    function checkSticky() {
      if (!stickyEnabled) return;
      const scrollY = window.pageYOffset;
      if (scrollY >= (originalTop - stickyOffset)) pinSection();
      else unpinSection();
    }

    let scrollTicking = false;
    function onScroll() {
      if (!scrollTicking) {
        window.requestAnimationFrame(function () {
          checkSticky();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }

    if (stickyEnabled) {
      window.addEventListener('load', measureSection);
      measureSection();
      setTimeout(measureSection, 100);
      setTimeout(measureSection, 500);
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        const wasPinned = isPinned;
        if (wasPinned) unpinSection();
        measureSection();
        if (wasPinned) checkSticky();
      }, { passive: true });
      checkSticky();
    }

    bubbles.forEach(function (bubble) {
      bubble.addEventListener('click', function (e) {
        const linkType = bubble.dataset.linkType;
        if (linkType !== 'anchor') return;
        const targetId = bubble.dataset.target;
        if (!targetId) return;
        const target = document.getElementById(targetId);
        if (!target) return;
        e.preventDefault();
        const offset = (isPinned ? section.offsetHeight : originalHeight) + stickyOffset;
        const targetTop = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: targetTop, behavior: 'smooth' });
        history.replaceState(null, '', '#' + targetId);
        setActiveBubble(targetId);
      });
    });

    function setActiveBubble(targetId) {
      bubbles.forEach(function (b) {
        const isActive = b.dataset.target === targetId;
        b.classList.toggle('is-active', isActive);
        if (isActive && window.innerWidth <= 768) scrollBubbleIntoView(b);
      });
    }

    function scrollBubbleIntoView(bubble) {
      const wrap = section.querySelector('.category-bubbles-wrap');
      if (!wrap) return;
      const targetScroll = bubble.offsetLeft - (wrap.offsetWidth / 2) + (bubble.offsetWidth / 2);
      wrap.scrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
    }

    const targets = [];
    bubbles.forEach(function (b) {
      if (b.dataset.linkType !== 'anchor') return;
      const id = b.dataset.target;
      const el = id ? document.getElementById(id) : null;
      if (el) targets.push(el);
    });

    if (targets.length && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        let bestEntry = null;
        let bestRatio = 0;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > bestRatio) {
            bestRatio = entry.intersectionRatio;
            bestEntry = entry;
          }
        });
        if (bestEntry) setActiveBubble(bestEntry.target.id);
      }, {
        rootMargin: '-' + (originalHeight + 50) + 'px 0px -40% 0px',
        threshold: [0, 0.1, 0.25, 0.5]
      });
      targets.forEach(function (t) { observer.observe(t); });
    }

    if (window.location.hash) {
      const initialId = window.location.hash.slice(1);
      if (document.getElementById(initialId)) setActiveBubble(initialId);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        constructor() {
            super();
        }
  
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.headerBounds = {};
    
            if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
            };
    
            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
    
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
    
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
    
            this.createObserver();
        }
  
        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }
  
        createObserver() {
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
    
            observer.observe(this.header);
        }
  
        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
    
            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (this.preventHide) return;
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
        
                    this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                    }, 66);
        
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
    
            this.currentScrollTop = scrollTop;
        }
  
        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }
  
        reveal() {
            const headerMultiSite = document.querySelector('.section-header-nav-multi-site');
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            if (headerMultiSite) {
                const height = headerMultiSite.offsetHeight;
                this.header.style.top = `${height}px`;
            }
        }
  
        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }
  
    customElements.define('sticky-header-mobile', StickyHeaderMobile);

    document.querySelector('[data-mobile-menu]').addEventListener('click', () => {
        document.body.classList.toggle('menu_open');
    })

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    };

    function renderLogoMobile() {
        if ($("[data-menu-tab]").length > 0) {

            $(document).on("click", "[data-menu-tab] li", (event) => {
                var active = $(event.currentTarget).data("load-page"),
                    href = $(event.currentTarget).attr("href");

                $.cookie("page-url", active, {
                    expires: 1,
                    path: "/",
                });
            });

            var canonical = $("[canonical-shop-url]").attr("canonical-shop-url"),
            pageUrl = $.cookie("page-url"),
            menuTabItem,
            logoTabItem,
            menuItem;

            if (
                window.location.pathname.indexOf("/pages/") !== -1 &&
                window.page_active &&
                window.page_active != pageUrl
            ) {
                setCookie("page-url", window.page_active, 1);
                pageUrl = window.page_active;
            }
            
            if (pageUrl != null) {
                menuTabItem = $(`[data-load-page="${pageUrl}"]`);
                logoTabItem = $(`[data-load-logo-page="${pageUrl}"]`);
                menuItem = $(`[data-load-menu-page="${pageUrl}"]`);
            } else {
                menuTabItem = $("[data-load-page].is-active");
                logoTabItem = $("[data-load-logo-page].first");
                menuItem = $("[data-load-menu-page].is-active");
            }

            var menuTab = menuTabItem.closest("[data-menu-tab]");

            menuTab
                .find("[data-load-page]")
                .not(menuTabItem)
                .removeClass("is-active");
                logoTabItem.siblings().removeClass("is-active");
                menuItem.siblings().removeClass("is-active");
            if (pageUrl != "") {
                logoTabItem.addClass("is-active");
                menuTabItem.addClass("is-active");
                menuItem.addClass("is-active");
            } else {
                $("[data-load-page]:nth-child(1)").addClass("is-active");
                $("[data-load-logo-page]:nth-child(1)").addClass("is-active");
                $("[data-load-menu-page]:nth-child(1)").addClass("is-active");
            }

            const header = menuTabItem.closest(".header");

            
            if (header && window.innerWidth < 1025) {
                if (
                    window.location.pathname.indexOf("/pages/") !== -1 &&
                    window.page_active &&
                    window.page_active != pageUrl
                ) {
                    setCookie("page-url", window.page_active, 1);
                    pageUrl = window.page_active;
                }

                const logoMobile = $(".header-mobile .header__heading-link");
                const logDesktop = header.find(".header__heading-link.is-active");

                if (logDesktop.data("logo-mobile") == undefined) {
                    logoMobile.find("img").addClass("logo-show");
                    return;
                } else {
                    logoMobile.html(
                    `<img src="${logDesktop.data(
                        "logo-mobile"
                    )}" alt="${logDesktop.data(
                        "logo-mobile-alt"
                    )}" style="max-width: ${logoMobile.data(
                        "logo-width"
                    )}px; height: auto"/>`
                    );

                    logoMobile.find("img").addClass("logo-show");
                    if (pageUrl != "" && pageUrl != null)
                    logoMobile.attr("href", pageUrl);
                }
            }
        }
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            if(this.headerIsAlwaysSticky != 'always'){
                                this.header.classList.add('shopify-section-header-hidden');
                            }
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
        super();
        }

        connectedCallback() {
        this.header = document.querySelector('.section-header-navigation');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
        };

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');
        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
        }

        setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
        }

        onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');
            requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            document.body.classList.add('scrolled-header');

            if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
            } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            document.body.classList.remove('scrolled-header');
            requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
        this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
            }
        }

        closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            //   if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
            //       if (document.body.classList.contains('template-index')) {
            //           if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
            //               $('.vertical-menu').removeClass('vertical-menu__hide');
            //           }
            //       }
            //   }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-footer-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    const stickyFooter = document.getElementById('StickyFooterCta');
    if (!stickyFooter) return;

    const buyBtn      = document.getElementById('StickyFooterBuyBtn');
    const priceEl     = document.getElementById('StickyFooterPrice');
    const mrpEl       = document.getElementById('StickyFooterMRP');
    const mrpWrapEl   = document.getElementById('StickyFooterMRPWrap');
    const savingsEl   = document.getElementById('StickyFooterSavings');
    const savingsAmtEl= document.getElementById('StickyFooterSavingsAmount');
    const imageEl     = document.getElementById('StickyFooterImage');
    const dailyEl     = document.getElementById('StickyFooterDaily');
    const ratingEl    = document.getElementById('StickyFooterRating');
    const countEl     = document.getElementById('StickyFooterReviewCount');

    const config = {
      productId:       stickyFooter.dataset.productId,
      productHandle:   stickyFooter.dataset.productHandle,
      scrollMode:      stickyFooter.dataset.scrollMode || 'after-atc',
      scrollThreshold: parseInt(stickyFooter.dataset.scrollThreshold, 10) || 400,
      hideNearFooter:  stickyFooter.dataset.hideNearFooter === 'true',
      reviewSource:    stickyFooter.dataset.reviewSource || 'auto',
      fallbackRating:  stickyFooter.dataset.fallbackRating,
      fallbackCount:   stickyFooter.dataset.fallbackCount,
      widthMode:       stickyFooter.dataset.widthMode || 'auto',
      widthCustom:     parseInt(stickyFooter.dataset.widthCustom, 10) || 1200
    };

    /* ============================================================
       ADAPTIVE WIDTH — match product page container on desktop
       ============================================================ */
    function getProductContainer() {
      // Most specific → least specific. First match wins.
      const candidates = [
        '.shopify-section--main-product .page-width',
        '.shopify-section[id*="main-product"] .page-width',
        'main .product__media-wrapper',
        '.product__media-wrapper',
        '.product-template__container',
        '.product-single__container',
        '[data-section-type="product"] .page-width',
        '[data-section-type="product"] .container',
        'main .page-width',
        'main .container',
        'main > .shopify-section .page-width',
        '.product-section .container',
        '.main-content .container'
      ];
      for (let i = 0; i < candidates.length; i++) {
        const el = document.querySelector(candidates[i]);
        if (el) {
          const w = el.getBoundingClientRect().width;
          if (w > 320) return el; // sanity check
        }
      }
      return null;
    }

    function syncWidthToPage() {
      if (config.widthMode === 'full-width') {
        // CSS handles full-width via .width-mode-full-width class
        return;
      }
      if (config.widthMode === 'custom') {
        stickyFooter.style.setProperty('--sticky-footer-max-width', config.widthCustom + 'px');
        return;
      }
      // auto: detect product container width — bar will match it but capped to keep the floating-card look
      const container = getProductContainer();
      if (container) {
        const rect = container.getBoundingClientRect();
        // Cap at 1300 so very wide containers don't make the bar feel edge-to-edge
        const w = Math.min(Math.round(rect.width), 1300);
        if (w > 320) {
          stickyFooter.style.setProperty('--sticky-footer-max-width', w + 'px');
        }
      } else {
        // Fallback: use viewport-based reasonable default
        stickyFooter.style.setProperty('--sticky-footer-max-width', '1100px');
      }
    }

    syncWidthToPage();
    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncWidthToPage, 80);
    }, { passive: true });
    // Re-sync after first paint (in case product container loads async)
    setTimeout(syncWidthToPage, 300);
    setTimeout(syncWidthToPage, 1500);

    /* ============================================================
       SCROLL VISIBILITY (UNCHANGED)
       ============================================================ */
    const mainAtcSelector = [
      'product-form button[type="submit"]',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form__submit',
      '#AddToCart',
      '[name="add"]'
    ].join(',');
    const mainAtc = document.querySelector(mainAtcSelector);
    const pageFooter = document.querySelector('footer, .site-footer, #shopify-section-footer, .footer');

    function setVisible(visible) {
      stickyFooter.classList.toggle('is-visible', visible);
      stickyFooter.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function checkNearFooter() {
      if (!config.hideNearFooter || !pageFooter) return false;
      const rect = pageFooter.getBoundingClientRect();
      return rect.top < (window.innerHeight - 100);
    }

    function updateVisibility() {
      // Never re-show while the cart drawer is open — it takes priority.
      if (stickyFooter.classList.contains('is-cart-open')) return;

      if (checkNearFooter()) { setVisible(false); return; }
      switch (config.scrollMode) {
        case 'always':
          stickyFooter.classList.add('is-always-on');
          stickyFooter.setAttribute('aria-hidden', 'false');
          break;
        case 'after-atc':
          if (mainAtc) {
            const rect = mainAtc.getBoundingClientRect();
            setVisible(rect.bottom < 0);
          } else {
            setVisible(window.scrollY > config.scrollThreshold);
          }
          break;
        case 'threshold':
          setVisible(window.scrollY > config.scrollThreshold);
          break;
        case 'instant':
          setVisible(window.scrollY > 50);
          break;
        default:
          setVisible(window.scrollY > config.scrollThreshold);
      }
    }

    if (config.scrollMode === 'always') {
      stickyFooter.classList.add('is-always-on');
      stickyFooter.setAttribute('aria-hidden', 'false');
    }

    let ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();

    /* ============================================================
       MONEY FORMATTING — uses INR by default, falls back gracefully
       ============================================================ */
    /* Match the shop's own money format instead of hardcoding "₹".
       A rendered sample ("₹ 0.00") tells us the currency prefix/suffix,
       so JS-updated prices sit flush with the Liquid-rendered ones. */
    const moneySample = stickyFooter.dataset.moneySample || '₹0.00';
    const moneyPrefix = (moneySample.match(/^[^\d]*/) || [''])[0];
    const moneySuffix = (moneySample.match(/[^\d]*$/) || [''])[0];

    function formatMoney(cents) {
      const value = (cents || 0) / 100;
      try {
        return moneyPrefix + value.toLocaleString('en-IN', { maximumFractionDigits: 0 }) + moneySuffix;
      } catch (e) {
        return moneyPrefix + Math.round(value) + moneySuffix;
      }
    }

    // Daily cost needs paise precision (₹16.65/day), unlike the headline price.
    function formatDaily(cents) {
      const value = (cents || 0) / 100;
      try {
        return moneyPrefix + value.toLocaleString('en-IN', {
          minimumFractionDigits: 2, maximumFractionDigits: 2
        }) + moneySuffix;
      } catch (e) {
        return moneyPrefix + value.toFixed(2) + moneySuffix;
      }
    }

    // Capsule count = the leading number in the variant title ("60", "90").
    // One capsule a day, so capsules == days of supply.
    function capsulesFromTitle(title) {
      const match = String(title || '').match(/\d+/);
      return match ? parseInt(match[0], 10) : 0;
    }

    /* ============================================================
       VARIANT SYNC — Multi-strategy approach
       ============================================================
       Strategy 1: Fetch /products/{handle}.js once, cache variants
       Strategy 2: Watch URL ?variant= changes (pushState + popstate)
       Strategy 3: Listen to ALL option-picker change events
       Strategy 4: MutationObserver on hidden variant ID input
       Strategy 5: Custom events (variant:change, product:variant-change)
       ============================================================ */
    let cachedVariants = null;
    let productLoadPromise = null;

    /* What is actually painted into the bar right now — set by
       updateFromVariant, never in advance. Liquid rendered the first state, so
       seed it from the markup. Recording a variant as applied *before* it had
       rendered was what let a single stale write latch permanently: every later
       attempt to paint the correct variant matched the guard and returned. */
    let renderedVariantId = String(stickyFooter.dataset.variantId || '');

    /* The variant the customer last explicitly chose (pack card, variant
       picker, variant:change event) and when. Several of the strategies below
       re-read the product form on a timer; on a live PDP the form can be
       rewritten back to its server-rendered value by Shopify's installment
       block or an app a few hundred ms after the click. Inside this window a
       timed read that disagrees with the choice is a stale re-render, not a
       new selection. */
    let chosenVariantId = null;
    let chosenAt = 0;
    const CHOICE_WINDOW = 1500;

    function noteChoice(variantId) {
      chosenVariantId = String(variantId);
      chosenAt = Date.now();
    }

    function isStaleWrite(variantId) {
      if (!chosenVariantId || String(variantId) === chosenVariantId) return false;
      return (Date.now() - chosenAt) < CHOICE_WINDOW;
    }

    /* Money strings pre-formatted by Liquid, keyed by variant id, published by
       the pack selector. Preferred over formatMoney() so the bar always shows
       exactly what the product page shows. */
    const formattedByVariant = {};

    let pricePulseTimer = null;

    function loadProductData() {
      if (cachedVariants) return Promise.resolve(cachedVariants);
      if (productLoadPromise) return productLoadPromise;
      if (!config.productHandle) return Promise.resolve(null);

      productLoadPromise = fetch('/products/' + config.productHandle + '.js', {
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Product fetch failed: ' + res.status);
          return res.json();
        })
        .then(function (data) {
          cachedVariants = data.variants || [];
          return cachedVariants;
        })
        .catch(function (err) {
          console.warn('[StickyFooter] Could not fetch product JSON:', err.message);
          productLoadPromise = null;
          return null;
        });
      return productLoadPromise;
    }

    function findVariantById(variantId) {
      if (!cachedVariants || !variantId) return null;
      const idStr = String(variantId);
      for (let i = 0; i < cachedVariants.length; i++) {
        if (String(cachedVariants[i].id) === idStr) return cachedVariants[i];
      }
      return null;
    }

    /* Paint a variant, if it is one of THIS product's own variants.
       An id we cannot resolve is left alone entirely — recommendation cards,
       quick-add forms and the installment block all carry variant ids that are
       none of our business, and letting one of them become the bar's state is
       what used to wedge it.

       options.explicit — came from a real selection, so it also records the
                          choice and is never treated as a stale write.
       options.force    — repaint even if this variant is already on screen
                          (used when better, Liquid-formatted money arrives). */
    function applyVariantId(variantId, options) {
      if (!variantId) return;
      const opts = options || {};
      const idStr = String(variantId);

      if (!opts.explicit && isStaleWrite(idStr)) return;
      if (!opts.explicit && !opts.force && idStr === renderedVariantId) return;

      const cached = findVariantById(idStr);
      if (cached) {
        if (opts.explicit) noteChoice(idStr);
        if (opts.force || idStr !== renderedVariantId) updateFromVariant(cached);
        return;
      }

      // Not cached yet — it may still be ours, so resolve and re-check. Time
      // has passed by the time this runs, so the guards are applied again.
      loadProductData().then(function () {
        const v = findVariantById(idStr);
        if (!v) return; // not this product's variant — leave the bar untouched
        if (!opts.explicit && isStaleWrite(idStr)) return;
        if (opts.explicit) noteChoice(idStr);
        if (opts.force || idStr !== renderedVariantId) updateFromVariant(v);
      });
    }

    function updateFromVariant(variant) {
      if (!variant) return;

      // Liquid-formatted strings win when we have them.
      const fmt = formattedByVariant[String(variant.id)] || {};

      renderedVariantId = String(variant.id);
      stickyFooter.setAttribute('data-variant-id', variant.id);
      stickyFooter.classList.toggle('is-soldout', !variant.available);

      if (buyBtn) {
        buyBtn.setAttribute('data-variant-id', variant.id);
        buyBtn.disabled = !variant.available;
        buyBtn.textContent = variant.available ? 'BUY NOW' : 'SOLD OUT';
      }

      // Price — written now, not on a timer. Deferring the text meant the
      // price could land after a later update had already run, leaving it
      // showing one variant while the MRP and savings beside it showed
      // another. The pulse is a class flip only, so it cannot reorder.
      if (priceEl) {
        priceEl.textContent = fmt.price || formatMoney(variant.price);
        priceEl.classList.add('is-updating');
        clearTimeout(pricePulseTimer);
        pricePulseTimer = setTimeout(function () {
          priceEl.classList.remove('is-updating');
        }, 120);
      }

      // MRP / compare-at price
      const cap = variant.compare_at_price || 0;
      if (cap > variant.price) {
        if (mrpEl) mrpEl.textContent = fmt.compare || formatMoney(cap);
        if (mrpWrapEl) mrpWrapEl.style.display = '';
      } else {
        if (mrpWrapEl) mrpWrapEl.style.display = 'none';
      }

      // Savings
      const saved = cap - variant.price;
      if (saved > 0) {
        if (savingsAmtEl) savingsAmtEl.textContent = fmt.savings || formatMoney(saved);
        if (savingsEl) savingsEl.style.display = '';
      } else {
        if (savingsEl) savingsEl.style.display = 'none';
      }

      // Image — use variant featured image, then product image fallback
      if (imageEl && variant.featured_image && variant.featured_image.src) {
        imageEl.src = variant.featured_image.src;
      }

      // Per-day cost — Liquid's figure when available, else recalculated
      // from this variant's own pack size.
      if (dailyEl) {
        const caps = capsulesFromTitle(variant.title);
        if (fmt.daily) {
          dailyEl.textContent = fmt.daily + '/day';
        } else if (caps > 0) {
          dailyEl.textContent = formatDaily(variant.price / caps) + '/day';
        } else if (dailyEl.dataset.fallbackDaily) {
          dailyEl.textContent = dailyEl.dataset.fallbackDaily + '/day';
        }
      }
    }

    /* ----- Strategy 1: Preload product data ----- */
    loadProductData();

    /* ----- Strategy 2: URL change watching ----- */
    function getVariantFromUrl() {
      try {
        const params = new URLSearchParams(window.location.search);
        return params.get('variant');
      } catch (e) {
        const match = window.location.search.match(/[?&]variant=(\d+)/);
        return match ? match[1] : null;
      }
    }

    let lastUrlVariant = getVariantFromUrl();
    function checkUrlVariant() {
      const current = getVariantFromUrl();
      if (current && current !== lastUrlVariant) {
        lastUrlVariant = current;
        applyVariantId(current);
      }
    }
    window.addEventListener('popstate', checkUrlVariant);

    // Intercept history.pushState / replaceState so URL-driven variant changes fire
    ['pushState', 'replaceState'].forEach(function (method) {
      const original = history[method];
      history[method] = function () {
        const result = original.apply(this, arguments);
        setTimeout(checkUrlVariant, 0);
        return result;
      };
    });

    /* ----- Strategy 3: Option picker change events ----- */
    /* The variant id held by a cart form for THIS product.
       Deliberately not "the first /cart/add form on the page": on a live PDP
       that is the Shop Pay installment form, and further down the page sit
       recommendation and quick-add forms for entirely different products. Only
       a form already holding one of this product's own variants counts, and
       the installment form is used only as a last resort — Shopify re-renders
       it, so it is the one most likely to be holding a stale value. */
    function getCurrentFormVariantId() {
      const inputs = document.querySelectorAll(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"], form[action*="/cart/add"] select[name="id"]'
      );
      let fallback = null;
      for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];
        if (!input.value || !findVariantById(input.value)) continue;
        const form = input.form || input.closest('form');
        const marks = form ? (form.id || '') + ' ' + (form.className || '') : '';
        if (/installment/i.test(marks)) {
          if (!fallback) fallback = input.value;
          continue;
        }
        return input.value;
      }
      return fallback;
    }

    // ALL option picker / variant input change events
    document.addEventListener('change', function (e) {
      const target = e.target;
      if (!target || !target.matches) return;

      const isVariantInput = target.matches('input[name="id"], select[name="id"]');
      const isOptionInput  = target.matches(
        'input[name^="options"], select[name^="options"], ' +
        'variant-radios input, variant-selects select, ' +
        'fieldset.product-form__input input, fieldset.product-form__input select, ' +
        '[data-option-position] input, [data-option-position] select, ' +
        '.product-form__input input[type="radio"], .product-form__input select'
      );

      if (!isVariantInput && !isOptionInput) return;

      if (isVariantInput && target.value) {
        applyVariantId(target.value, { explicit: true });
        return;
      }

      // Option picker changed — wait briefly for theme JS to update the hidden variant input & URL
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) {
          applyVariantId(formVariant);
        } else {
          checkUrlVariant();
        }
      }, 60);
      // Try again after slow themes have settled
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 250);
    }, true);

    // Also handle click events on radio-style swatches that don't always fire 'change'
    document.addEventListener('click', function (e) {
      const target = e.target.closest(
        '[data-variant-id], [data-option-value], ' +
        '.product-form__input label, .swatch-element, ' +
        'variant-radios label, .product-option label'
      );
      if (!target) return;

      // Direct variant ID on click target
      const directVariantId = target.dataset.variantId;
      if (directVariantId) {
        applyVariantId(directVariantId, { explicit: true });
        return;
      }

      // Otherwise wait for theme to apply changes
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 80);
      setTimeout(function () {
        const formVariant = getCurrentFormVariantId();
        if (formVariant) applyVariantId(formVariant);
        else checkUrlVariant();
      }, 350);
    }, true);

    /* ----- Strategy 4: MutationObserver on hidden variant input ----- */
    // watchVariantInput runs several times to catch async-rendered forms, so
    // inputs already being watched must be skipped — otherwise the same input
    // ends up with three observers and three polling intervals.
    const watchedInputs = new WeakSet();

    function watchVariantInput() {
      const inputs = document.querySelectorAll(
        'product-form input[name="id"], form[action*="/cart/add"] input[name="id"]'
      );
      if (!inputs.length || !('MutationObserver' in window)) return;

      inputs.forEach(function (input) {
        if (watchedInputs.has(input)) return;
        watchedInputs.add(input);

        // Watch attribute changes
        const attrObserver = new MutationObserver(function () {
          if (input.value) applyVariantId(input.value);
        });
        attrObserver.observe(input, { attributes: true, attributeFilter: ['value'] });

        // Direct property changes (some themes set .value via JS without changing attr)
        let last = input.value;
        setInterval(function () {
          if (input.value && input.value !== last) {
            last = input.value;
            applyVariantId(input.value);
          }
        }, 300);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watchVariantInput);
    } else {
      watchVariantInput();
    }
    // Re-watch after async-loaded product forms
    setTimeout(watchVariantInput, 1000);
    setTimeout(watchVariantInput, 3000);

    /* ----- Strategy 5: Custom theme events ----- */
    const customEvents = ['variant:change', 'product:variant-change', 'productVariantChanged', 'on:variant:change'];
    customEvents.forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!e.detail) return;

        // Cache any Liquid-formatted money strings before applying, so the
        // update below renders them instead of re-deriving from cents.
        const vid = e.detail.variantId || e.detail.id ||
                    (e.detail.variant && e.detail.variant.id);
        if (e.detail.formatted && vid) {
          formattedByVariant[String(vid)] = e.detail.formatted;
        }

        // A broadcast selection is authoritative: force the repaint even when
        // this variant is already on screen, so the Liquid-formatted money
        // cached just above replaces anything formatMoney() derived, and keep
        // the guard in step with what is now painted.
        if (e.detail.variant) {
          noteChoice(e.detail.variant.id);
          updateFromVariant(e.detail.variant);
        } else if (e.detail.variantId) {
          applyVariantId(e.detail.variantId, { explicit: true, force: true });
        } else if (e.detail.id) {
          applyVariantId(e.detail.id, { explicit: true, force: true });
        }
      });
    });

    /* ============================================================
       AUTO REVIEW EXTRACTION (UNCHANGED)
       ============================================================ */
    const reviewExtractors = {
      'judge.me': function () {
        const badge = document.querySelector('.jdgm-prev-badge, .jdgm-widget [data-average-rating]');
        if (!badge) return null;
        const rating = badge.getAttribute('data-average-rating');
        const count  = badge.getAttribute('data-number-of-reviews');
        if (!rating && !count) return null;
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  count ? parseInt(count, 10) : null,
          source: 'Judge.me'
        };
      },
      'yotpo': function () {
        const widget = document.querySelector('.yotpo-bottomline, .yotpo-display-wrapper');
        if (!widget) return null;
        const ratingEl = widget.querySelector('[class*="star-rating"], .yotpo-stars');
        const countEl  = widget.querySelector('.text-m, .yotpo-bottomline a, .yotpo-sum-reviews');
        const rating = ratingEl && (ratingEl.getAttribute('data-score') || (ratingEl.getAttribute('aria-label') || '').match(/[\d.]+/));
        const countMatch = countEl && countEl.textContent.match(/\d+/);
        return {
          rating: rating ? (Array.isArray(rating) ? rating[0] : rating).toString() : null,
          count:  countMatch ? parseInt(countMatch[0], 10) : null,
          source: 'Yotpo'
        };
      },
      'loox': function () {
        const widget = document.querySelector('.loox-rating, [data-loox-rating]');
        if (!widget) return null;
        const rating = widget.getAttribute('data-rating');
        const count  = widget.getAttribute('data-count') || widget.getAttribute('data-num-reviews');
        const text   = widget.textContent || '';
        const countMatch = count || (text.match(/\((\d+)\)/) || [])[1];
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  countMatch ? parseInt(countMatch, 10) : null,
          source: 'Loox'
        };
      },
      'stamped': function () {
        const badge = document.querySelector('.stamped-product-reviews-badge, .stamped-badge');
        if (!badge) return null;
        const rating = badge.getAttribute('data-rating');
        const count  = badge.getAttribute('data-reviews') || badge.getAttribute('data-review-count');
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  count ? parseInt(count, 10) : null,
          source: 'Stamped.io'
        };
      },
      'shopify-reviews': function () {
        const badge = document.querySelector('.spr-badge, [data-rating]');
        if (!badge) return null;
        const rating = badge.getAttribute('data-rating');
        const countEl = badge.querySelector('.spr-badge-caption');
        const countMatch = countEl && countEl.textContent.match(/\d+/);
        return {
          rating: rating ? parseFloat(rating).toFixed(1) : null,
          count:  countMatch ? parseInt(countMatch[0], 10) : null,
          source: 'Shopify Reviews'
        };
      },
      'json-ld': function () {
        const scripts = document.querySelectorAll('script[type="application/ld+json"]');
        for (let i = 0; i < scripts.length; i++) {
          try {
            const data = JSON.parse(scripts[i].textContent);
            const items = Array.isArray(data) ? data : [data];
            for (let j = 0; j < items.length; j++) {
              const item = items[j];
              const agg = item.aggregateRating || (item['@graph'] && item['@graph'].find(function (x) { return x.aggregateRating; }));
              if (agg && agg.aggregateRating) {
                return {
                  rating: parseFloat(agg.aggregateRating.ratingValue).toFixed(1),
                  count:  parseInt(agg.aggregateRating.reviewCount || agg.aggregateRating.ratingCount, 10),
                  source: 'JSON-LD'
                };
              }
              if (agg && agg.ratingValue) {
                return {
                  rating: parseFloat(agg.ratingValue).toFixed(1),
                  count:  parseInt(agg.reviewCount || agg.ratingCount, 10),
                  source: 'JSON-LD'
                };
              }
            }
          } catch (e) { /* skip */ }
        }
        return null;
      }
    };

    function formatCount(num) {
      if (!num || isNaN(num)) return null;
      if (num >= 100000) return (num / 100000).toFixed(1).replace(/\.0$/, '') + 'L+';
      if (num >= 1000)   return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K+';
      return num + '+';
    }

    function applyReviewData(data) {
      if (!data) return false;
      let updated = false;
      if (data.rating && ratingEl) {
        ratingEl.textContent = '★ ' + data.rating;
        updated = true;
      }
      if (data.count && countEl) {
        countEl.textContent = formatCount(data.count);
        updated = true;
      }
      // Reveal only now that at least one real value is in place. ratingEl and
      // countEl are null-guarded above and have to be here too — reading
      // .textContent off a missing element throws and takes out the rest of
      // this script, including the reveal itself.
      if (updated) {
        const reviewsEl = document.getElementById('StickyFooterReviews');
        const sepEl     = document.getElementById('StickyFooterReviewSep');
        const labelEl   = document.getElementById('StickyFooterReviewLabel');
        const hasRating = !!(ratingEl && ratingEl.textContent);
        const hasCount  = !!(countEl && countEl.textContent);
        // The separator needs both sides, and a bare "reviews" with no number
        // in front of it reads as broken.
        if (sepEl)   sepEl.hidden   = !(hasRating && hasCount);
        if (labelEl) labelEl.hidden = !hasCount;
        if (reviewsEl) reviewsEl.hidden = false;
        console.log('[StickyFooter] Reviews loaded from:', data.source);
      }
      return updated;
    }

    function extractReviews() {
      let data = null;
      if (config.reviewSource === 'auto') {
        const order = ['judge.me', 'yotpo', 'loox', 'stamped', 'shopify-reviews', 'json-ld'];
        for (let i = 0; i < order.length; i++) {
          data = reviewExtractors[order[i]]();
          if (data && (data.rating || data.count)) break;
        }
      } else if (reviewExtractors[config.reviewSource]) {
        data = reviewExtractors[config.reviewSource]();
      }
      applyReviewData(data);
      return data;
    }

    extractReviews();
    setTimeout(extractReviews, 1000);
    setTimeout(extractReviews, 3000);

    if ('MutationObserver' in window) {
      let extractAttempts = 0;
      const reviewObserver = new MutationObserver(function () {
        if (extractAttempts > 8) { reviewObserver.disconnect(); return; }
        extractAttempts++;
        const result = extractReviews();
        if (result && result.rating && result.count) reviewObserver.disconnect();
      });
      reviewObserver.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { reviewObserver.disconnect(); }, 10000);
    }

    /* ============================================================
       CART DRAWER DETECTION — hide footer while cart is open
       ============================================================
       No standard "cart open" flag exists, so we detect via:
         1. Known open-state selectors on the drawer element
         2. Cart-specific open classes on <body> / <html>
         3. Theme cart open/close events
         4. Esc-key safety net
       Any signal toggles .is-cart-open on the footer; CSS hides it.

       NOTE: We deliberately exclude generic nav-drawer classes
       (bare `js-drawer-open`, bare `.drawer--is-open`) because on
       Impulse/Debut those also fire for the mobile MENU. Only
       cart-specific signals are matched here. If your custom theme
       uses a different class, add it to the lists below (see the
       console snippet in the accompanying notes to find it).
       ============================================================ */
    (function initCartDrawerHide() {
      const OPEN_SELECTORS = [
        'cart-drawer.active',             // Dawn / Symmetry
        'cart-drawer.is-open',
        'cart-drawer[open]',
        '#CartDrawer.active',             // Debut / Brooklyn
        '#CartDrawer.drawer--is-open',
        '.drawer--right.drawer--is-open', // Impulse (right = cart)
        '.cart-drawer.active',
        '.cart-drawer.is-open',
        '.cart-drawer--active',
        '.mini-cart.is-open',
        '.mini-cart.active',
        '.mini_cart.opened',              // Wokiee
        '.cart-flyout.is-open',
        '[data-cart-drawer].is-open',
        '[data-cart-drawer].active',
        '.Drawer--cart.is-open',          // Prestige-style
        '.js-drawer-open--right',
        '.halo-cart-sidebar.open',        // Halo theme (right cart sidebar)
        '.halo-sidebar.halo-cart-sidebar.open'
      ];

      const BODY_OPEN_CLASSES = [
        'js-drawer-open--right',          // Impulse cart (right drawer)
        'cart-drawer-open',
        'cart-drawer--open',
        'cart-open',
        'js-cart-open',
        'cart--opened',
        'cart-is-open',
        'scroll-lock-cart',
        'cart-opening',                   // Halo variants
        'halo-cart-open',
        'sidebar-cart-open'
      ];

      // Live visibility test — true if the given sidebar element is actually
      // on-screen. Handles themes (like some Halo builds) that swap the node
      // or toggle the open state on a wrapper we can't reliably name.
      function isElementOnScreen(el) {
        if (!el) return false;
        const cs = window.getComputedStyle(el);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) {
          return false;
        }
        const rect = el.getBoundingClientRect();
        if (rect.width < 40 || rect.height < 40) return false;
        // Closed right-sidebars sit off the right edge (transform/right); open ones sit inside.
        return rect.left < (window.innerWidth - 20) && rect.right > 20;
      }

      function isCartOpen() {
        // 1. Class-flip selectors
        for (let i = 0; i < OPEN_SELECTORS.length; i++) {
          if (document.querySelector(OPEN_SELECTORS[i])) return true;
        }
        // 2. body / html open classes
        const b = document.body ? document.body.classList : null;
        const h = document.documentElement.classList;
        for (let i = 0; i < BODY_OPEN_CLASSES.length; i++) {
          if ((b && b.contains(BODY_OPEN_CLASSES[i])) || h.contains(BODY_OPEN_CLASSES[i])) return true;
        }
        // 3. Live re-query + visibility fallback (Halo + any custom drawer).
        //    Re-queried every call so a swapped/re-rendered node is never stale.
        const liveDrawers = document.querySelectorAll(
          '.halo-cart-sidebar, cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer], .mini-cart, .mini_cart, .drawer--cart, .cart-flyout, .Drawer--cart'
        );
        for (let i = 0; i < liveDrawers.length; i++) {
          const el = liveDrawers[i];
          if (el.classList.contains('open') || el.classList.contains('active') || el.classList.contains('is-open')) {
            return true;
          }
          if (isElementOnScreen(el)) return true;
        }
        return false;
      }

      function evaluate() {
        if (isCartOpen()) {
          stickyFooter.classList.add('is-cart-open');
          stickyFooter.setAttribute('aria-hidden', 'true');
        } else if (stickyFooter.classList.contains('is-cart-open')) {
          stickyFooter.classList.remove('is-cart-open');
          // Restore correct scroll-based visibility + aria state
          updateVisibility();
        }
      }

      // 1. Watch class/attribute flips on <html>, <body>, and drawer nodes
      if ('MutationObserver' in window) {
        const mo = new MutationObserver(function () {
          window.requestAnimationFrame(evaluate);
        });
        const opts = { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden', 'style'] };
        mo.observe(document.documentElement, opts);
        if (document.body) mo.observe(document.body, opts);

        document.querySelectorAll(
          'cart-drawer, .cart-drawer, #CartDrawer, [data-cart-drawer], .mini-cart, .mini_cart, .drawer--cart, .cart-flyout, .Drawer--cart, .halo-cart-sidebar'
        ).forEach(function (d) { mo.observe(d, opts); });
      }

      // 2. Theme cart open/close events
      ['cart:open', 'drawer:open', 'cartDrawer:open', 'on:cart-drawer:open', 'cart-drawer:open']
        .forEach(function (evt) {
          document.addEventListener(evt, function () {
            stickyFooter.classList.add('is-cart-open');
            stickyFooter.setAttribute('aria-hidden', 'true');
          }, false);
        });
      ['cart:close', 'drawer:close', 'cartDrawer:close', 'on:cart-drawer:close', 'cart-drawer:close']
        .forEach(function (evt) {
          document.addEventListener(evt, function () {
            window.requestAnimationFrame(evaluate);
          }, false);
        });

      // 3. Safety net — Esc key often closes the drawer
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) setTimeout(evaluate, 80);
      });

      // 4. Lightweight poll — guarantees detection on themes (e.g. some Halo
      //    builds) that neither fire an event nor mutate an element we observe.
      //    Cheap: a few class checks + one getBoundingClientRect, 3x/second.
      setInterval(evaluate, 350);

      evaluate();
    })();

    /* ============================================================
       BUY NOW HANDLER (UNCHANGED - reads from current sticky variant)
       ============================================================ */
    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        const variantId = buyBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        buyBtn.disabled = true;
        const originalText = buyBtn.textContent;
        buyBtn.textContent = 'ADDING...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) {
            console.error('[StickyFooter] ATC failed:', err);
            buyBtn.disabled = false;
            buyBtn.textContent = originalText;
            window.location.href = '/cart/' + variantId + ':1';
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
